/** Hărțile ECU și piesele, exact ca structurile Rust (powertrain.rs), serializate în camelCase. */
export interface Ecu {
  rpm: number[];
  boostBar: number[];
  timingDeg: number[];
  lambda: number[];
  torqueLimitNm: number[];
  fuel: number[];
  limiterRpm: number;
  speedLimitKmh: number;
  launchRpm: number;
}

export interface Parts {
  turboScale: number;
  intercooler: number;
  exhaust: number;
  intake: number;
  injectors: number;
  forged: boolean;
  clutch: number;
  octane: number;
}

export const STOCK_PARTS: Parts = { turboScale: 1, intercooler: 0.65, exhaust: 1, intake: 1, injectors: 1, forged: false, clutch: 1, octane: 95 };

export type MapKey = 'boostBar' | 'timingDeg' | 'lambda' | 'torqueLimitNm' | 'fuel';

export const MAPS: Array<{ key: MapKey; label: string; unit: string; step: number; min: number; max: number; diesel?: boolean; petrol?: boolean; turbo?: boolean }> = [
  { key: 'boostBar', label: 'Presiune turbo țintă', unit: 'bar', step: 0.05, min: 0, max: 3, turbo: true },
  { key: 'timingDeg', label: 'Avans față de serie', unit: '°', step: 0.5, min: -10, max: 12, petrol: true },
  { key: 'lambda', label: 'λ țintă / limită de fum', unit: 'λ', step: 0.01, min: 0.7, max: 1.6 },
  { key: 'torqueLimitNm', label: 'Limitator de cuplu', unit: 'N·m', step: 10, min: 50, max: 1500 },
  { key: 'fuel', label: 'Cantitate injectată / îmbogățire', unit: '×', step: 0.02, min: 0.5, max: 2 }
];

/** Rândurile dyno-ului: rpm, N·m, kW, bar, λ, EGT °C, avans efectiv °. */
export interface DynoRow { rpm: number; nm: number; kw: number; boost: number; lambda: number; egt: number; timing: number }

export function dynoRows(flat: Float32Array): DynoRow[] {
  const out: DynoRow[] = [];
  for (let i = 0; i + 6 < flat.length; i += 7) out.push({ rpm: flat[i], nm: flat[i + 1], kw: flat[i + 2], boost: flat[i + 3], lambda: flat[i + 4], egt: flat[i + 5], timing: flat[i + 6] });
  return out;
}
